<template>
  <div class="kw_scan_input">
    <el-form-item :label="value.fieldCnName" :rules="!value.ifHide && (!value.styleSet || value.styleSet.showStyle!=7)?value.elRules:null" :prop="'fieldSet.'+fieldSetindex+'.defaultValStr'" class="Signing_form" >
      <template slot="label" v-if="(value.styleSet.titleNameHide!=2)">
        <span :style="value.styleSet.pageFieldNameStyleSet?value.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{value.fieldCnName + ':'}}</span>
      </template>
      <el-input :ref="('field_'+fieldSetindex)" :id="('field_'+fieldSetindex)" v-model="value.defaultValStr" size="mini" type="textarea" class="searchInput" :placeholder="(value.styleSet.searchPlaceholder?value.styleSet.searchPlaceholder:'')" :style="value.styleSet.pageFieldValueStyleSet?value.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet"  @blur="noFocus" @focus="getedFocus">
        <!-- @change="bindElementChange" -->
        <el-tooltip v-if="value.fieldDescribe" slot="append" effect="dark" :content="value.fieldDescribe" placement="top">
          <kw_icon  type="message_fill" />
        </el-tooltip>
      </el-input>
      <el-button type="primary" v-if="!scanState" @click="changeFocusState">{{scanButtonName}}</el-button>
      <!-- <span v-else >结束盘点1</span> -->
      <!-- <el-button type="primary" @click="alert('aaaa');" v-else >结束盘点1</el-button> -->
    </el-form-item>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_scan_input',
  props: {
    value: {
      type: Object,
      default: {}
    },
    nowDataId: {
      default: 0
    },
    filedIndex:{
      type:String,
      default:null
    },
    hidden:{
      type:Boolean,
      default:false
    },
    pageSetInfo:{
      type: Object,
      default: {}
    },
    // 第几条数据
    nowDataIndex:{
      type: String,
      default: ''
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    },
    fieldSetindex:{
      type:Number,
      defaultStatus:0
    }
  },
  data() {
    return {
      scanState:false,
      //扫描几个
      scanNumber:0,
      scanButtonName:"点击开始盘点"
    };
  },
  created() {
    var that = this;
    //
    if(that.value.styleSet) {
      if(that.value.styleSet.ifScanNum == 1) {
        that.scanNumber = 1;
      }
      if(that.value.styleSet.scanButtonName) {
        that.scanButtonName = that.value.styleSet.scanButtonName;
      }
    }
    
  },
  mounted() {
    var that = this;
    that.$nextTick(()=>{
      console.log("延迟获取焦点-------------------");
      that.getFocus();
    })
    setTimeout(function(){
      console.log("1秒后获取焦点-------------------");
      that.getFocus();
    }, 3000);
  },
  beforeDestroy(){
    
  },
  destroyed(){

  },
  watch:{
    'value.defaultValStr'(newVal,oldVal){
      console.log("kw_scan_input=======watch=========",newVal,oldVal);
      if(this.scanNumber == 1) {
        if(this.$refs['field_'+this.fieldSetindex]) {
          this.$refs['field_'+this.fieldSetindex].blur();
        }
      }
      this.bindElementChange();
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    text(){
      console.log("text===========================");
    },
    getFocus(){
      if(this.$refs['field_'+this.fieldSetindex]) {
        console.log("获取焦点----333-----", this.$refs['field_'+this.fieldSetindex]);
        this.$refs['field_'+this.fieldSetindex].focus();
        // this.scanState = true;
        // $("#field_0").focus;
      }
    },
    changeFocusState(){
      console.log("this.scanState========111=========",this.scanState);
      this.scanState = !this.scanState;
      console.log("this.scanState========222=========",this.scanState);
      if(this.scanState) {
        this.getFocus();
      }
    },
    getedFocus(){
      this.scanState = true;
    },
    noFocus(){
      this.scanState = false;
    },
    bindElementChange(){
      var that = this;
      that.$emit("bindElementChange",that.value,that.fieldSetindex);
      // var fieldId = that.value.fieldId;
      // if(typeof(that["zdyValueChange_"+fieldId]) == "function") {
      //   console.log("fieldId=========2222222================",fieldId);
      //     that["zdyValueChange_"+fieldId](that,utils,pageUtils);
      // }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
